/**
 * Realtime de leads (postgres_changes · schema core). Mismo patrón que
 * src/features/chat/realtime.ts. Las 3 tablas están en la publication
 * supabase_realtime (migración 20260612150000) y RLS owner-based filtra
 * los eventos que recibe cada suscriptor.
 */
import type { RealtimeChannel } from '@supabase/supabase-js';

import { supabase } from '@/lib/supabase';

export type LeadsRealtimeKind = 'conversation' | 'message' | 'draft';

export interface LeadsRealtimeEvent {
  kind: LeadsRealtimeKind;
  eventType: 'INSERT' | 'UPDATE' | 'DELETE';
  conversationId: string | null;
}

export function subscribeToLeads(
  onEvent: (event: LeadsRealtimeEvent) => void,
): RealtimeChannel {
  const ch = supabase.channel('leads-realtime');

  const subscribe = (
    table: 'lead_conversations' | 'lead_messages' | 'lead_response_drafts',
    kind: LeadsRealtimeKind,
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- tipado de
    // postgres_changes en supabase-js no acepta union de tablas dinámicas
    (ch as any).on(
      'postgres_changes',
      { event: '*', schema: 'core', table },
      (payload: {
        eventType: 'INSERT' | 'UPDATE' | 'DELETE';
        new: Record<string, unknown> | null;
        old: Record<string, unknown> | null;
      }) => {
        const row = payload.new ?? payload.old ?? {};
        const conversationId =
          (row.conversation_id as string | undefined) ??
          (kind === 'conversation' ? (row.id as string | undefined) : undefined) ??
          null;
        onEvent({ kind, eventType: payload.eventType, conversationId });
      },
    );
  };

  subscribe('lead_conversations', 'conversation');
  subscribe('lead_messages', 'message');
  subscribe('lead_response_drafts', 'draft');

  ch.subscribe();
  return ch;
}
